import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import OrganizationsPage from "@/pages/admin/OrganizationsPage";
import ScoutsPage from "@/pages/admin/ScoutsPage";
import AdminAccountPage from "@/pages/admin/AdminAccountPage";
import LeaguesPage from "@/pages/admin/LeaguesPage";
import LeagueDetailPage from "@/pages/admin/LeagueDetailPage";
import TeamsPage from "@/pages/admin/TeamsPage";
import PlayersPage from "@/pages/admin/PlayersPage";
import MatchesPage from "@/pages/admin/MatchesPage";
import PlayerDetailPage from "@/pages/admin/PlayerDetailPage";
import TeamDetailPage from "@/pages/admin/TeamDetailPage";
import ScoutLayout from "@/pages/scout/ScoutLayout";
import ScoutHomePage from "@/pages/scout/ScoutHomePage";
import ScoutAccountPage from "@/pages/scout/ScoutAccountPage";
import ScoutMatchesPage from "@/pages/scout/ScoutMatchesPage";
import ScoutPlayersPage from "@/pages/scout/ScoutPlayersPage";

import "@/App.css";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/scout"} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/organizations" replace />} />
            <Route path="organizations" element={<OrganizationsPage />} />
            <Route path="scouts" element={<ScoutsPage />} />
            <Route path="leagues" element={<LeaguesPage />} />
            <Route path="leagues/:id" element={<LeagueDetailPage basePath="/admin" />} />
            <Route path="teams" element={<TeamsPage />} />
            <Route path="teams/:id" element={<TeamDetailPage basePath="/admin" canImport={true} />} />
            <Route path="players" element={<PlayersPage />} />
            <Route path="players/:id" element={<PlayerDetailPage basePath="/admin" canImport={true} />} />
            <Route path="matches" element={<MatchesPage />} />
            <Route path="account" element={<AdminAccountPage />} />
          </Route>

          <Route
            path="/scout"
            element={
              <ProtectedRoute role="scout">
                <ScoutLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<ScoutHomePage />} />
            <Route path="players" element={<ScoutPlayersPage />} />
            <Route path="players/:id" element={<PlayerDetailPage basePath="/scout" canImport={false} />} />
            <Route path="teams" element={<TeamsPage basePath="/scout" canMutate={false} />} />
            <Route path="teams/:id" element={<TeamDetailPage basePath="/scout" canImport={false} />} />
            <Route path="leagues" element={<LeaguesPage basePath="/scout" canMutate={false} />} />
            <Route path="leagues/:id" element={<LeagueDetailPage basePath="/scout" />} />
            <Route path="matches" element={<ScoutMatchesPage />} />
            <Route path="account" element={<ScoutAccountPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
